module.exports = __webpack_public_path__ + "img/contents_title_sub12.008c4ffc.png";